export default "__VITE_ASSET__CcEQIRzx__"